<template>
  <div id="user-departments-slim-list">
    <div v-if="!minimum">
      <vs-table
        pagination
        :search="search"
        :data="departments"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <template slot="thead">
          <vs-th style="width: 50px" v-if="checkbox"></vs-th>
          <vs-th sort-key="name">Nome</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selecteds" :vs-value="tr.id"/>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else class="department-filter-scroll">
      <VuePerfectScrollbar :key="$vs.rtl" :settings="settings">
        <div v-if="!departments.length">
          <small>Sem dados disponíveis</small>
        </div>
        <div v-else :key="indextr" v-for="(tr, indextr) in departments" class="flex mb-2">
          <vs-td>
            <vs-checkbox v-model="selecteds" :vs-value="tr.id" :title="tr.name">
              <div class="flex">
                <p class="align-self-center">{{ tr.name | truncate(100, true) }}</p>
              </div>
            </vs-checkbox>
          </vs-td>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import moduleUserDepartment from "../../store/userDepartment/moduleUserDepartment";

  export default {
    components: { VuePerfectScrollbar },
    props: {
      checkbox: {
        type: Boolean,
        required: false
      },
      search: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      selecteds: {
        required: false,
        default(){ return [] },
        validator: prop => typeof prop === 'object' || prop === null
      },
      minimum: {
        type: Boolean,
        required: false,
        default(){ return false },
      },
    },
    data() {
      return {
        itemsPerPage: 4,
        settings: {
          wheelSpeed: .60,
          maxScrollbarLength: 60
        }
      }
    },
    computed: {
      departments() {
        if (!moduleUserDepartment.isRegistered) {
          this.$store.registerModule('userDepartment', moduleUserDepartment)
          moduleUserDepartment.isRegistered = true
        }

        return this.$store.state.userDepartment
            ? this.$store.state.userDepartment.userDepartments.filter(department => department.activated)
            : [];
      },
    },
    created() {
      if ( !this.departments.length ){
        this.$store.dispatch("userDepartment/fetch")
      }
    },
    watch: {
      selecteds: function() {
        this.$emit("selectedDepartment", this.selecteds);
      }
    }
  }
</script>

<style lang="scss">
  .department-filter-scroll{
    width: 100%;
    margin: auto;
    overflow-y: auto;
    position: relative;
    max-height: 6rem !important;
  }
</style>
